module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 17.57"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M0,5.68A5.51,5.51,0,0,1,3.32.44,5.44,5.44,0,0,1,9.26,1.6l.56.55a.22.22,0,0,0,.36,0l.57-.57A5.26,5.26,0,0,1,16.37.34,5.15,5.15,0,0,1,20,4.79a5.11,5.11,0,0,1-1.5,4.44C15.75,12,13,14.67,10.3,17.39c-.25.25-.37.25-.63,0L2.42,10.12A12.34,12.34,0,0,1,1,8.57,5.16,5.16,0,0,1,0,5.68Zm10,6.77h1.23c.39,0,.35.05.35-.34,0-.63,0-1.25,0-1.88,0-.22.07-.29.29-.28.65.06,1.3,0,2,0,.19,0,.26,0,.26-.25,0-.89,0-1.79,0-2.68,0-.21-.07-.25-.26-.25-.65,0-1.31,0-2,0-.21,0-.29,0-.28-.27,0-.65,0-1.3,0-2,0-.18,0-.25-.24-.25H8.65c-.19,0-.24.06-.24.24,0,.67,0,1.34,0,2,0,.18-.05.24-.23.23-.67,0-1.34,0-2,0-.2,0-.25.06-.25.26,0,.9,0,1.81,0,2.71,0,.19.08.21.23.21L8.1,10c.22,0,.33,0,.33.31,0,.66,0,1.31,0,2,0,.17.05.23.23.22Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-426d18e7","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/heartHealth.vue
// module id = e02ec76761721b7b545d
// module chunks = 89